import React from "react";
import { PageShell, EditableSection, EditableFeatureGrid } from "./PageShell";

const PILLARS = [
  { badge: "Pillar 01", title: "French-inspired composition", body: "Every Scentodore fragrance draws from the classical structure of French perfumery — layered top, heart, and base notes designed to unfold over the hours you wear them." },
  { badge: "Pillar 02", title: "Hand-poured in Canada", body: "Bottled in small batches at our Canadian atelier. Every bottle is filled, capped, and inspected by hand — no factory automation, no shortcuts." },
  { badge: "Pillar 03", title: "Accessible luxury", body: "High-oil concentration and premium ingredients, offered direct so the value stays in the bottle rather than in advertising and retail markups." },
];

const STORY = [{
  heading: "Our philosophy",
  body: "Scentodore was created for the person who believes fragrance is more than a finishing touch — it is an extension of identity. A signature. A first and last impression.\n\nWe make modern impressions of iconic luxury fragrances, poured at generous concentrations and delivered directly. No retail middlemen. No inflated markups. Just extraordinary scent.",
}];
const MEANING = [{
  heading: "Elevate Every Impression.",
  body: "That is the promise behind the name. Whether you’re walking into a boardroom, meeting someone for the first time, or simply present with yourself — the right scent should quietly do the work.\n\nWe build fragrances designed to be noticed at exactly the right distance: intimate at conversation range, memorable long after you’ve gone.",
}];
const FUTURE = [{
  heading: "Where we’re going",
  body: "We’re a young brand, and we intend to grow slowly — releasing new compositions only when we’re certain they deserve a place in the collection. Follow the journal to watch the maison unfold, one edition at a time.",
}];

export default function AboutPage() {
  return (
    <PageShell
      slug="about"
      testid="about"
      eyebrow="Our Story"
      title="A modern maison of impression."
      intro="Scentodore is a Canadian fragrance house creating French-inspired impressions of the world’s most iconic scents — hand-poured with care, offered without the mark-ups of traditional retail."
    >
      <EditableSection slug="about" sectionKey="story" fallback={STORY} />

      <div className="mb-14">
        <h2 className="font-serif text-xl sm:text-2xl text-[#1A1918] mb-4">What we stand for</h2>
        <EditableFeatureGrid slug="about" sectionKey="pillars" fallback={PILLARS} />
      </div>

      <EditableSection slug="about" sectionKey="meaning" fallback={MEANING} />
      <EditableSection slug="about" sectionKey="future" fallback={FUTURE} />
    </PageShell>
  );
}
